// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.contents1[data-v-f93d9bd2] {\n  box-sizing: border-box;\n  padding: 0.052083rem 0.135417rem 0.208333rem;\n}\n.contents1 .hide[data-v-f93d9bd2] .el-upload--picture-card {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
